try {
    window.$ = window.jQuery = require('jquery');
    window.moment = require('moment');
    window.jsignature = require('jsignature');

    require('bootstrap');
    require('admin-lte');
    require('datatables.net-bs4');
    require('datatables.net-responsive-bs4');
    require('tempusdominus-bootstrap-4');
    require('popper.js');
    require('bs-custom-file-input');
    require('daterangepicker');
    require('multiselect');

} catch (e) {}
